'use es6';

import http from 'hub-http/clients/apiClient';
import formatBusinessUnitDropdownOptions from 'reference-resolvers/formatters/formatBusinessUnitDropdownOptions';
export const createGetBusinessUnitDropdownOptions = ({
  httpClient,
  portalId
}) => () => httpClient.get('business-units/v1/business-unit-displays/user/dropdown', Object.assign({}, portalId && {
  query: {
    portalId
  }
})).then(formatBusinessUnitDropdownOptions);
export const getBusinessUnitDropdownOptions = createGetBusinessUnitDropdownOptions({
  httpClient: http
});